import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

interface TutorialMessage {
  visible: boolean;
  nextStep: boolean;
  lastStep: boolean;
  text: string;
}

@Component({
  selector: 'app-tutorial-dialog',
  templateUrl: './tutorial-dialog.component.html',
  styleUrls: ['./tutorial-dialog.component.css']
})
export class TutorialDialogComponent {

  public messages: TutorialMessage[] = [];

  constructor(public dialogRef: MatDialogRef<TutorialDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
    for (let index = 0; index < data.messages.length; index++) {
      const message: TutorialMessage = {
        visible: index === 0,
        nextStep: index !== data.messages.length - 1,
        lastStep: index > 0,
        text: data.messages[index]
      };
      this.messages.push(message);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}


// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/tutorial-dialog/tutorial-dialog.component.ts